import type { Prose } from './types';

/**
 * Pick the language half of a bilingual field.
 *
 * The account arrives BILINGUAL from the model — `{en, es}` per field, authored
 * in one call from the same facts. i18next covers the dialog CHROME only and
 * never the account text: translating prose in the client would be a second,
 * ungrounded generation, which is precisely what this feature forbids.
 *
 * The other language is used only as a FALLBACK for an empty half, so a
 * half-authored chapter still says what it knows instead of rendering blank.
 * That is a language choice, not invented content — both halves came from the
 * same guarded generation.
 */
export function pickProse(prose: Prose | null | undefined, language: string | undefined): string {
  if (!prose || typeof prose !== 'object') return '';
  const wantsEs = (language ?? '').toLowerCase().startsWith('es');
  const primary = wantsEs ? prose.es : prose.en;
  const secondary = wantsEs ? prose.en : prose.es;
  if (typeof primary === 'string' && primary.trim()) return primary;
  return typeof secondary === 'string' ? secondary : '';
}
